import { useCallback, useMemo } from "react"
import { useQuery } from "urql"

import type { GoodsReceiptPalletRow } from "@/graphql/codegen/graphql"
import { GetGoodsReceiptPalletRowsListDocument } from "@/graphql/codegen/graphql"

interface UseGetGoodsReceiptPalletRowsReturn {
  palletRows: GoodsReceiptPalletRow[]
  isFetching: boolean
  error: Error | undefined
  refetch: () => void
}

export const useGetGoodsReceiptPalletRows = (goodsReceiptId?: string | null): UseGetGoodsReceiptPalletRowsReturn => {
  const [{ data, fetching, error }, reexecuteQuery] = useQuery({
    query: GetGoodsReceiptPalletRowsListDocument,
    variables: {
      input: {
        filter: { goodsReceiptId },
        limit: 10000,
        offset: 0,
      },
    },
  })

  const refetch = useCallback(() => {
    reexecuteQuery({ requestPolicy: "network-only" })
  }, [reexecuteQuery])

  const palletRows = useMemo<GoodsReceiptPalletRow[]>(() => {
    if (data?.goodsReceipt.palletRowList.__typename !== "GoodsReceiptPalletRowListSuccess") {
      return []
    }

    return data.goodsReceipt.palletRowList.goodsReceiptPalletRows as GoodsReceiptPalletRow[]
  }, [data])

  return {
    palletRows,
    isFetching: fetching,
    error,
    refetch,
  }
}
